BaseModel = require './base_model.coffee'

class global.SharpspringSetting extends BaseModel
  @ATTRIBUTES = {
    id: {}
    metadata: { default: {}, type: Object }
    triggers: { default: { on_created: false, status: ['connected'], stages: [] }, type: Object }
    use_carousel: { default: true }
  }



// WEBPACK FOOTER //
// ./src/models/sharpspring_setting.coffee